module.exports = __webpack_public_path__ + "img/hodo_qr.81d45da8.svg";